import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRiverGaugeAlerts } from 'features/riverGauges/hooks/useRiverGaugeAlerts';
import { useAuthState } from 'state/useAuthState';
import { ButtonProps } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { MEMBERSHIP_PLANS } from '../../../../constants';

type UseCreateAlertButton = Pick<ButtonProps, 'disabled' | 'onClick'> & {
  component: typeof Link;
  to: string;
};

const getLinkPath = (input: {
  riverGaugeId?: string | number;
  canCreate: boolean;
}): string => {
  const { canCreate, riverGaugeId } = input;

  if (riverGaugeId && canCreate) {
    return `/gauge/${riverGaugeId}/alert/create`;
  }

  return `/support_us/?plan=${MEMBERSHIP_PLANS.yearly}`;
};

export const useCreateAlertButton = (
  riverGaugeId?: string | number,
): UseCreateAlertButton => {
  const { t } = useTranslation();
  const { showMembershipFeatures } = useAuthState();
  const { riverGaugeAlerts = [], isLoading, isError } = useRiverGaugeAlerts();

  return {
    component: Link,
    to: getLinkPath({
      riverGaugeId,
      canCreate: !riverGaugeAlerts.length || showMembershipFeatures,
    }),
    disabled: !riverGaugeId || isLoading,
    onClick: isError
      ? (e) => {
          e.preventDefault();
          enqueueSnackbar(t('common.errorMessage'), { variant: 'error' });
        }
      : undefined,
  };
};
